export default __webpack_public_path__ + "static/media/TravelBackpackHiking1.172000d9.jpg";